import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import onFlightCombinationSelected from 'state/checkoutPage/flights/operations/onFlightCombinationSelected';
import getFlightsCombinationByProductToken from 'state/checkoutPage/flights/selectors/getFlightsCombinationByProductToken';
import formatFlightsDataForFlightsDetails from 'state/checkoutPage/flightsDetails/transforms/formatFlightsDataForFlightsDetails';
import FlightDetailsModalComponent from './FlightDetailsModalComponent';

const propTypes = {
  productToken: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  onClickClose: PropTypes.func.isRequired,
};

const defaultProps = {
  modalOpen: false,
};

class FlightDetailsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flightsCombination: null,
      checked: false,
      price: 0,
    };

    this.onAfterOpen = this.onAfterOpen.bind(this);
    this.onAfterClose = this.onAfterClose.bind(this);
    this.handleOnClickSelect = this.handleOnClickSelect.bind(this);
    this.handleOnChangeSelected = this.handleOnChangeSelected.bind(this);
  }

  static getDerivedStateFromProps(props) {
    const { productToken, selectedFlightsProductToken } = props;
    return {
      checked: selectedFlightsProductToken && productToken === selectedFlightsProductToken,
    };
  }

  onAfterOpen() {
    const { productToken, airportNamesMap, carrierNamesMap, getFlightsCombinationByProductToken } = this.props;
    const flightsCombination = getFlightsCombinationByProductToken(productToken);

    this.setState({
      flightsCombination: formatFlightsDataForFlightsDetails(flightsCombination, airportNamesMap, carrierNamesMap),
      price: flightsCombination.prices.perPerson,
    });
  }

  onAfterClose() {
    const { resetDataOnClose } = this.props;
    resetDataOnClose && this.setState({ flightsCombination: null });
  }

  handleOnClickSelect(event) {
    if (event.target.dataset.isCheckbox === 'true') {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      event.preventDefault();
    }

    this.handleOnChangeSelected();
  }

  handleOnChangeSelected() {
    const { productToken, onFlightCombinationSelected } = this.props;
    const { checked } = this.state;

    if (checked) {
      return;
    }

    onFlightCombinationSelected([productToken]);

    this.props.onClickClose();
  }

  render() {
    return (
      <FlightDetailsModalComponent
        {...this.props}
        {...this.state}
        onAfterOpen={this.onAfterOpen}
        onAfterClose={this.onAfterClose}
        onChangeSelected={this.handleOnChangeSelected}
        onClickSelect={this.handleOnClickSelect}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedFlightsProductToken:
      state.checkoutPageTravelSummary.selectedFlights && state.checkoutPageTravelSummary.selectedFlights[0],
    airportNamesMap: state.checkoutPageFlights.airportNamesMap,
    carrierNamesMap: state.checkoutPageFlights.carrierNamesMap,
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFlightsCombinationByProductToken(productToken) {
      return dispatch(getFlightsCombinationByProductToken(productToken));
    },
    onFlightCombinationSelected(selectedFlights) {
      dispatch(onFlightCombinationSelected(selectedFlights));
    },
  };
}

FlightDetailsModal.propTypes = propTypes;
FlightDetailsModal.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(FlightDetailsModal);
